module.exports = __webpack_public_path__ + "static/media/builtin.be118812.png";